@if (show) {
  <div class="w-[85%] mx-auto pb-4 backdrop-blur-md">
    <div class="flex items-center gap-2 rounded bg-[var(--neutral-50)] px-4 py-2 text-sm text-white backdrop-blur-xl">
      <mat-icon inline>arrow_upward</mat-icon>
      {{ label }}
    </div>
  </div>
}
